import { useNavigate, useRoutes } from 'react-router-dom'

// import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
// import LocalizationProvider from '@mui/lab/LocalizationProvider'

import { CircularProgress, CssBaseline } from '@mui/material'
import ThemeProvider from './pages/admins/theme/ThemeProvider'
import { useEffect, useState } from 'react'
import routesDev from './routers/router-dev'
import routesPublic from './routers/router-public'
import routesAdmin from './routers/router-admin'
import { Helmet } from 'react-helmet-async'
import { useUser } from './contexts/UserContext'
import routesSupervisor from './routers/router-supervisor'
import routesMobileOnly from './routers/router-mobile-only'
import { Suspense, lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import SuspenseLoader from './components/SuspenseLoader'
import 'dayjs/locale/nl'
// import TermsDialog from './components/Terms'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { nl } from 'date-fns/locale'

// `/privacy` (23-9-2026) is public in every role: the app, the stores and the
// agreement all link to it, signed in or not.
const PrivacyPage = lazy(() => import('./pages/privacy'))
const PrivacyStatement = () => (
  <Suspense fallback={<SuspenseLoader />}>
    <PrivacyPage />
  </Suspense>
)
const withPublicPages = (routes: RouteObject[]): RouteObject[] => [
  { path: '/privacy', element: <PrivacyStatement /> },
  ...routes,
]

// import { IPublicClientApplication } from '@azure/msal-browser'
// import { MsalProvider } from '@azure/msal-react'
// import { CustomNavigationClient } from './constants/NavigationClient'

// type AppProps = {
//   pca: IPublicClientApplication
// }

function App() {
  const { userData } = useUser()
  const navigate = useNavigate()
  const [role, setRole] = useState('')
  // const [acceptTerms, setAcceptTerms] = useState(false)

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!userData) {
      setLoading(false)
      // Tidak ada data pengguna, arahkan ke rute publik
      // navigate('/')
    } else {
      // Tentukan peran pengguna berdasarkan data pengguna
      switch (userData.roles) {
        case 'beheerder':
          setRole('beheerder')
          break
        case 'superbeheerder':
          setRole('superbeheerder')
          break
        case 'behandelaar':
          setRole('behandelaar')
          break
        case 'client':
          setRole('client')
          break
        default:
          setRole('public')
          break
      }
    }
  }, [userData, loading])

  // FB-8: the client onboarding flow lived on the web only; it moved to
  // the mobile app together with the rest of the client surface, so there
  // is nothing left to redirect into here.
  useEffect(() => {
    if (!userData) {
      return
    }

    setLoading(false)
  }, [userData, navigate, setLoading, role])

  // Hooks must run on every render — call `useRoutes` before any
  // conditional return so hook order stays stable. Loading state is
  // rendered inside the routes shell below instead of via an early
  // return (legacy correctness fix; original FE violated rules of
  // hooks by ordering the early-return before this `useRoutes` call).
  const routes = useRoutes(
    withPublicPages(
      role === 'beheerder'
        ? routesAdmin
        : role === 'superbeheerder'
          ? routesDev
          : role === 'behandelaar'
            ? routesSupervisor
            : role === 'client'
              ? routesMobileOnly
              : routesPublic
    )
  )

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nl}>
        <CssBaseline />
        <Helmet>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
        </Helmet>
        {loading ? <CircularProgress /> : routes}
      </LocalizationProvider>
    </ThemeProvider>
  )
}
export default App
